import React from 'react';

const sections = [
  {
    title: '1. Acceptance of Terms',
    content: `By accessing or using the SalesPad platform and related services (the "Service") provided by SALESPAD PTE. LTD. ("SalesPad", "we", "our", or "us"), you agree to be bound by these Terms & Conditions ("Terms"). If you are entering into these Terms on behalf of an organisation, you represent that you have the authority to bind that organisation. If you do not agree to these Terms, do not use the Service.`,
  },
  {
    title: '2. Description of Service',
    content: `SalesPad is an AI-powered B2B sales automation platform that provides tools for lead generation, multi-channel outreach (email, LinkedIn, WhatsApp, phone), pipeline management, and meeting scheduling. The Service is provided on a subscription basis and is intended for business use only.`,
  },
  {
    title: '3. Eligibility',
    content: `You must be at least 18 years old and capable of entering into a legally binding agreement to use the Service. The Service is intended for commercial or professional use. Use by consumers for personal, family, or household purposes is not permitted.`,
  },
  {
    title: '4. Account Registration',
    content: `You must register for an account to access the Service. You agree to provide accurate, current, and complete information and to keep it updated. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately at legal@salespad.app if you suspect unauthorised access.`,
  },
  {
    title: '5. Subscription and Payment',
    content: `Access to the Service is provided on a paid subscription basis. Subscription fees are billed in advance on a monthly or annual basis as selected at sign-up. All fees are exclusive of taxes, which you are responsible for paying. Fees are non-refundable except as expressly set out in these Terms or required by applicable law. We reserve the right to change pricing with 30 days' notice to existing subscribers.`,
  },
  {
    title: '6. Free Trials',
    content: `We may offer a free trial period. At the end of the trial, you will be automatically charged the applicable subscription fee unless you cancel before the trial ends. We reserve the right to modify or terminate free trial offers at any time.`,
  },
  {
    title: '7. Acceptable Use',
    content: `You agree to use the Service only for lawful purposes and in accordance with these Terms. You must not: use the Service to send unsolicited communications in violation of applicable anti-spam laws (including CAN-SPAM, CASL, GDPR, or equivalent); scrape, harvest, or collect data without authorisation; attempt to gain unauthorised access to any part of the Service or its underlying systems; use the Service to transmit malware or malicious code; impersonate any person or entity; or use the Service in any manner that could damage, disable, or overburden our infrastructure.`,
  },
  {
    title: '8. User Content and Data',
    content: `You retain all ownership rights to data, contacts, templates, and content you upload or input into the Service ("User Content"). By using the Service, you grant SalesPad a limited, non-exclusive, worldwide licence to process User Content solely to provide and improve the Service. You represent that you have all necessary rights and permissions to use and share User Content through the Service, including rights to contact any individuals whose data you upload.`,
  },
  {
    title: '9. Intellectual Property',
    content: `All intellectual property rights in the Service, including software, algorithms, AI models, trademarks, logos, and documentation, are owned by SalesPad or its licensors. Nothing in these Terms grants you any rights to SalesPad's intellectual property other than the limited right to use the Service as described herein. You may not copy, modify, distribute, reverse-engineer, or create derivative works from any part of the Service without our prior written consent.`,
  },
  {
    title: '10. AI-Generated Outreach',
    content: `The Service uses artificial intelligence to generate and send outreach messages on your behalf. You acknowledge that: you are solely responsible for the content, legality, and compliance of all outreach sent through your account; SalesPad does not review individual messages before sending; and you must comply with all applicable laws governing electronic communications, including GDPR, CCPA, CAN-SPAM, CASL, and equivalent legislation in your jurisdiction. SalesPad disclaims all liability for outreach content generated at your direction.`,
  },
  {
    title: '11. Third-Party Integrations',
    content: `The Service may integrate with third-party platforms such as LinkedIn, WhatsApp, Google Workspace, HubSpot, and others. Your use of those platforms is subject to their respective terms of service. SalesPad is not responsible for the availability, accuracy, or conduct of any third-party platforms. We may suspend integrations if required by third-party platform policies.`,
  },
  {
    title: '12. Data Privacy',
    content: `Our collection and use of personal data in connection with the Service is governed by our Privacy Policy, which is incorporated into these Terms by reference. If you process personal data of EU/UK individuals through the Service, you may be required to enter into a Data Processing Agreement (DPA) with us. Please contact legal@salespad.app to request a DPA.`,
  },
  {
    title: '13. Confidentiality',
    content: `Each party agrees to keep confidential all non-public information of the other party that is designated as confidential or that reasonably should be understood to be confidential given the nature of the information and circumstances of disclosure. This obligation does not apply to information that is publicly available, independently developed, or required to be disclosed by law.`,
  },
  {
    title: '14. Disclaimer of Warranties',
    content: `THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT RESULTS OBTAINED FROM USE OF THE SERVICE WILL BE ACCURATE OR RELIABLE.`,
  },
  {
    title: '15. Limitation of Liability',
    content: `TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SALESPAD SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE. SALESPAD'S TOTAL AGGREGATE LIABILITY FOR ANY CLAIMS ARISING UNDER THESE TERMS SHALL NOT EXCEED THE TOTAL FEES PAID BY YOU TO SALESPAD IN THE THREE MONTHS PRECEDING THE CLAIM.`,
  },
  {
    title: '16. Indemnification',
    content: `You agree to indemnify, defend, and hold harmless SalesPad and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of or in connection with: your use of the Service; your User Content; your violation of these Terms; or your violation of any applicable law or third-party rights.`,
  },
  {
    title: '17. Term and Termination',
    content: `These Terms remain in effect for as long as you maintain an active subscription. Either party may terminate the agreement with 30 days' written notice. SalesPad may suspend or terminate your account immediately for material breach of these Terms, non-payment, or where required by law. Upon termination, your right to access the Service ceases immediately. We will provide you with an opportunity to export your data for 30 days following termination, after which it will be deleted in accordance with our Privacy Policy.`,
  },
  {
    title: '18. Modifications to the Service',
    content: `We reserve the right to modify, suspend, or discontinue any part of the Service at any time, with reasonable notice where practicable. We will not be liable to you or any third party for any modification, suspension, or discontinuation of the Service.`,
  },
  {
    title: '19. Changes to These Terms',
    content: `We may revise these Terms from time to time. We will provide at least 14 days' notice of material changes via email or a prominent notice within the Service. Your continued use of the Service after the effective date of the revised Terms constitutes your acceptance. If you do not agree to the changes, you must stop using the Service and cancel your subscription before the effective date.`,
  },
  {
    title: '20. Governing Law',
    content: `These Terms shall be governed by and construed in accordance with the laws of Singapore, without regard to its conflict of law principles. Any dispute arising out of or relating to these Terms or the Service shall be subject to the exclusive jurisdiction of the courts of Singapore, except where mandatory consumer protection laws in your jurisdiction require otherwise.`,
  },
  {
    title: '21. Dispute Resolution',
    content: `We encourage you to contact us first at legal@salespad.app to resolve any disputes informally. If a dispute cannot be resolved informally within 30 days, either party may pursue formal legal proceedings in the courts of Singapore as set out in Section 20.`,
  },
  {
    title: '22. Severability and Waiver',
    content: `If any provision of these Terms is found to be unenforceable, that provision will be limited or eliminated to the minimum extent necessary so that the remaining Terms remain in full force and effect. No waiver of any term or condition shall be deemed a further or continuing waiver of such term or any other term. SalesPad's failure to assert any right under these Terms shall not constitute a waiver of such right.`,
  },
  {
    title: '23. Contact Information',
    content: `If you have any questions about these Terms, please contact us at:`,
    contact: {
      email: 'legal@salespad.app',
      company: 'SALESPAD PTE. LTD.',
      country: 'Singapore',
    },
  },
];

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-page-bg" style={{ background: 'radial-gradient(1200px 600px at 75% 45%, rgba(61,139,255,0.10) 0%, rgba(255,86,201,0.07) 35%, rgba(7,15,31,0) 70%), linear-gradient(180deg, #0B1730 0%, #070F1F 100%)' }}>
      <header className="sticky top-0 z-50 border-b border-card-border bg-bg-surface/80 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center space-x-3">
          <img
            src="/landing-page/salespad logo.svg"
            alt="SalesPad Logo"
            className="w-7 h-7"
          />
          <span className="text-text-primary font-bold text-xl font-inter">SalesPad</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-12">
          <p className="text-sm font-medium text-text-secondary uppercase tracking-widest mb-4">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-black text-text-primary font-inter mb-4 gradient-text">
            Terms &amp; Conditions
          </h1>
          <p className="text-text-secondary text-base">
            SALESPAD PTE. LTD. &mdash; Singapore
          </p>
          <p className="text-text-secondary text-sm mt-1">Last updated: April 2025</p>
        </div>

        <div className="space-y-4">
          {sections.map((section, i) => (
            <div
              key={i}
              className="bg-bg-surface border border-card-border rounded-2xl p-6 sm:p-8"
            >
              <h2 className="text-text-primary font-bold text-lg sm:text-xl font-inter mb-3">
                {section.title}
              </h2>
              <p className="text-text-secondary text-sm sm:text-base leading-relaxed">
                {section.content}
              </p>
              {section.contact && (
                <div className="mt-4 space-y-1 text-sm text-text-secondary">
                  <p>{section.contact.company}</p>
                  <p>{section.contact.country}</p>
                  <p>
                    Email:{' '}
                    <a
                      href={`mailto:${section.contact.email}`}
                      className="text-brand-green-teal hover:underline"
                    >
                      {section.contact.email}
                    </a>
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
